export function GetPriceRule() {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/RequestApi/GetPriceRule', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    }
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}

export function requestOTP(data) {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/SessionApi/RequestOtp', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    },
                    body: JSON.stringify(data)
                })
                    .then(async res => {
                        // Check if the response has a body
                        const contentType = res.headers.get('content-type');
                        if (!contentType || !contentType.includes('application/json')) {
                            // No JSON response, return null or do something else
                            return {
                                resStatusCode: res.status,
                            };
                        } 
                        return await res.json()
                    })
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}

export function ValidateOTP(data) {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/RequestApi/ValidateOTP', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    },
                    body: JSON.stringify(data)
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}

export function RegisterMarriage(data) {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/MarriageApi/RegisterMarriage', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    },
                    body: JSON.stringify(data)
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}

export function RegisterPayment(data) {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/PaymentApi/RegisterPayment', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    },
                    body: JSON.stringify(data)
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}

export function ValidateEmail(data) {
    return new Promise((resolve) =>
        setTimeout(() =>
            resolve(
                fetch(process.env.REACT_APP_API_URL + '/RequestApi/ValidateEmail', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'access-control-allow-origin': '*',
                        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
                    },
                    body: JSON.stringify(data)
                })
                    .then(res => res.json())
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    })
            )
        ), 0)
}
